import actions from './actions';

const { SEARCH_USER_BEGIN, SEARCH_USER_SUCCESS, SEARCH_USER_ERR } = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const userSearchReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SEARCH_USER_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_USER_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case SEARCH_USER_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  } 
};

export { userSearchReducer };
